<template>
	<div>
		<p class="font-medium text-gray-700" v-if="!noLabel">
			{{ __("Fulfilment Date") }}
		</p>
		<!-- date type -->
		<ui-validation-message
			:form="form"
			field="date.type"
			v-if="form.hasErrors"
		/>
		<div class="gap-x-6 gap-y-2 mt-1 flex-wrap sm:flex space-y-2 sm:space-y-0">
			<ui-radio-group
				v-model="dateTypeChecker"
				radioValue="AT_HARVEST"
				:key="'AT_HARVEST-' + dateTypeChecker"
				:form="form"
				field="date.type"
				name="date.type"
				class="whitespace-nowrap"
				label="At Harvest"
				tooltip-text="After mutual coordination during harvest."
			>
			</ui-radio-group>

			<ui-radio-group
				v-model="dateTypeChecker"
				radioValue="MONTH"
				:key="'MONTH-' + dateTypeChecker"
				:form="form"
				field="date.type"
				name="date.type"
				class="whitespace-nowrap"
				label="Month"
				tooltip-text="Month of fulfillment."
			>
			</ui-radio-group>

			<ui-radio-group
				v-model="dateTypeChecker"
				radioValue="MULTIPLE"
				:key="'MULTIPLE-' + dateTypeChecker"
				:form="form"
				field="date.type"
				name="date.type"
				class="whitespace-nowrap"
				label="Consecutive Months without Storage Fee"
				tooltip-text="Pick up in a predefined time period."
			>
			</ui-radio-group>

			<ui-radio-group
				v-model="dateTypeChecker"
				radioValue="BASIS"
				:key="'BASIS-' + dateTypeChecker"
				:form="form"
				field="date.type"
				name="date.type"
				class="whitespace-nowrap"
				label="Consecutive Months with Storage Fee"
				tooltip-text="Contract with flexible storage period, which provides for payment of the warehouse (report) from the following month of the closing until the collection of goods. The time of collection / delivery of goods is at the choice of the buyer"
			>
			</ui-radio-group>
		</div>

		<div
			class="mt-4 flex gap-x-6 gap-y-2 flex-wrap align-baseline"
			v-if="dateTypeChecker == 'MONTH'"
		>
			<ui-month-input-group
				v-model="form.date.month_to"
				field="date.month_to"
				label="Month"
				:form="form"
				:required="true"
				:key="'MONTH_TO-' + dateTypeChecker"
				:minDate="getHarvestYearAsMinDate"
			></ui-month-input-group>
		</div>

		<!-- :class="'grid-cols-' + gridCols" -->
		<div
			class="mt-4 flex gap-x-6 gap-y-2 flex-wrap items-center"
			v-else-if="['MULTIPLE', 'BASIS'].includes(dateTypeChecker)"
		>
			<ui-month-input-group
				class="min-w-48"
				v-model="form.date.month_from"
				field="date.month_from"
				label="Month From"
				:form="form"
				:required="true"
				:key="'MONTH_FROM-' + dateTypeChecker"
				:minDate="getHarvestYearAsMinDate"
			></ui-month-input-group>

			<ui-month-input-group
				class="min-w-48"
				v-model="form.date.month_to"
				field="date.month_to"
				label="Month To"
				:form="form"
				:required="true"
				:key="'MONTH_TO-' + dateTypeChecker"
				:minDate="getHarvestYearAsMinDate"
			></ui-month-input-group>

			<div
				class="flex flex-wrap gap-x-4 md:mt-6"
				v-if="dateTypeChecker == 'MULTIPLE'"
			>
				<ui-radio-group
					name="multiple_mode"
					v-model="form.date.multiple_mode"
					radioValue="CONSECUTIVE"
					:key="'CONSECUTIVE-' + form.date.multiple_mode"
					:form="form"
					field="date.multiple_mode"
					label="Successively"
				/>
				<ui-radio-group
					name="multiple_mode"
					v-model="form.date.multiple_mode"
					radioValue="BY_AGREEMENT"
					:key="'BY_AGREEMENT-' + form.date.multiple_mode"
					:form="form"
					field="date.multiple_mode"
					label="By Agreement"
				/>
			</div>

			<div
				class="text-sm text-gray-500"
				v-if="dateTypeChecker == 'BASIS' && userType == 'FARMER'"
			>
				{{ __("Storage fees:") }} {{ storageFee }} €/t
				{{ __("half-monthly from the 1st half of the following month.") }}
				{{ __("Fulfillment according to buyer's demand.") }}
			</div>

			<div
				class="text-sm text-gray-500"
				v-if="dateTypeChecker == 'BASIS' && userType != 'FARMER' && !open"
			>
				{{ __("Storage fees:") }} {{ storageFee }} €/t
				<ui-tooltip
					class="text-green-400"
					:icon-stroke-width="2"
					icon-class="ml-1 w-4 h-4"
					:text="
						__(
							`half-monthly from the 1st half of the following month. Fulfillment according to buyer's demand.`
						)
					"
				/>
				<ui-button
					class="hover:bg-gray-100 rounded-lg p-2 text-orange-500"
					v-on:click="open = true"
					type="blank"
				>
					<ui-icon name="edit-2" class="text-orange h-6 w-6" stroke-width="2" />
				</ui-button>
			</div>
			<ui-input-group
				v-if="dateTypeChecker == 'BASIS' && userType != 'FARMER' && open"
				v-model="form.date.storage_fee"
				field="date.storage_fee"
				label="Storage fees"
				:form="form"
				:required="true"
				:dp="2"
			/>
			<ui-validation-message
				:form="form"
				field="form.date.multiple_mode"
				v-if="form.hasErrors"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		gridCols: {
			type: String,
			default: "4",
		},
		noLabel: {
			type: Boolean,
			default: false,
		},
		setHarvestYearAsMinDate: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		let today = new Date();
		return {
			open: false,
			userType: this.$inertia.page.props.user?.type,
			getHarvestYearAsMinDate: this.setHarvestYearAsMinDate
				? this.form.product.harvest + "-07-01"
				: today.toISOString().substr(0, 8) + "01",
		};
	},
	computed: {
		dateTypeChecker: {
			get() {
				return this.form.date.type;
			},
			set(newValue) {
				this.form.date.type = newValue;

				if (newValue == "AT_HARVEST") {
					this.form.date.month_from = null;
					this.form.date.month_to = null;
					this.form.date.multiple_mode = null;
				} else if (newValue == "MONTH") {
					this.form.date.month_from = null;
					this.form.date.multiple_mode = null;
				} else if (newValue == "BASIS") {
					this.form.date.multiple_mode = null;
				} else {
					this.form.date.multiple_mode = "BY_AGREEMENT";
				}
			},
		},
		storageFee() {
			if (this.form.date.storage_fee) {
				return this.form.date.storage_fee;
			} else {
				let storageFee = "0.60";
				if (this.form.location.hub != null) {
					if (this.form.product.type == "WHEAT") {
						storageFee = "0.80";
					} else if (this.form.product.type == "BARLEY") {
						storageFee = "0.70";
					}
				}
				this.form.date.storage_fee = storageFee; // not so nice, but hey...
				return storageFee;
			}
		},
	},
};
</script>
